import RestClientService from "@/core/services/restClient.service";
import {
  AuthMeResponse,
  ChangePasswordDto,
  ForgotPasswordDto,
  LoginDto,
  ResetPasswordDto,
  ChangeNumberDto,
  UpdateUserProfileDto,
  VerifyAuthenticatorDto,
  VerifyDisableTwoFactorOtpDto,
} from "@/modules/Profile/dtos/auth.dto";
import { API_PATH } from "@/core/constants/apiPath";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { LoginResponseModel } from "@/core/models/loginResponse.model";

class AuthService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public login(body: LoginDto): Promise<ICoreResponse<LoginResponseModel>> {
    return this.restClient.post(API_PATH.login, body);
  }

  public forgotPassword(body: ForgotPasswordDto): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.forgotPassword, body);
  }

  public resetPassword(body: ResetPasswordDto): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.changePassword, body);
  }

  public changePassword(body: ChangePasswordDto): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.resetPassword, body);
  }

  public changeNumber(body: ChangeNumberDto): Promise<ICoreResponse> {
    return this.restClient.patch(API_PATH.changePhoneNumber, body);
  }

  public getUserProfile(): Promise<ICoreResponse<AuthMeResponse>> {
    return this.restClient.get(API_PATH.me);
  }

  public updateUserProfile(body: UpdateUserProfileDto): Promise<ICoreResponse> {
    if (body.public_id) {
      return this.restClient.patch(API_PATH.me + body.public_id + "/", {
        is_multi_factor_enabled: body.is_multi_factor_enabled,
      });
    } else {
      return this.restClient.patch(API_PATH.me, body);
    }
  }

  public verifyAuthenticator(
    body: VerifyAuthenticatorDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.verifyAuthenticator, body);
  }

  public verifyDisableTwoFactorOtp(
    body: VerifyDisableTwoFactorOtpDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(API_PATH.verifyDisableTwoFactorOtp, body);
  }
}

export default AuthService;
